// Keep track of who is selected
let previousMember = null;
let previousMemberBio = null;

document.querySelectorAll('.team-member').forEach((member, index) => {
    member.addEventListener('click', () => {
        let bioElement = member.querySelector('.bio');

        // Calculate row number based on index
        let row = Math.floor(index / 3) + 1;
        let bioContainer = document.querySelector('.row-' + row);

        if (member === previousMember) {
            if (bioContainer) {
                bioContainer.classList.remove('active');
            }
            if (bioElement) {
                bioElement.classList.remove('active');
            }
            previousMember = null;
            previousMemberBio = null;
        } else {
            if (previousMemberBio) {
                previousMemberBio.classList.remove('active');
            }
            if (bioElement) {
                let bio = bioElement.innerHTML;
                if (bioContainer) {
                    bioContainer.innerHTML = bio;
                    bioContainer.classList.add('active');
                }
                bioElement.classList.add('active');
            }
            previousMember = member;
            previousMemberBio = bioContainer;
        }
    });
});